import { AbstractControl, ValidatorFn } from '@angular/forms';

import { createValidationError } from '../../util';
import { PcsDate } from './pcs-date';
import { dateFromArray, isValidDate } from './utils';

const dateNotInRange = (date: Date, minDate: Date, maxDate: Date): boolean => (minDate && date < minDate) || (maxDate && date > maxDate);

export const dateInRangeValidator = (minDate: PcsDate, maxDate: PcsDate): ValidatorFn =>
  ((control: AbstractControl) => {
    if (control.value) {
      const date = dateFromArray(control.value);
      const min = minDate && dateFromArray(minDate);
      const max = maxDate && dateFromArray(maxDate);

      return !isValidDate(date) || dateNotInRange(date, min, max) ?
        createValidationError('dateNotInRange', 'date.not.in.range') : null;
    }
  });
